import { render, staticRenderFns } from "./colorpicker.vue?vue&type=template&id=5958cd80&scoped=true&"
import script from "./colorpicker.ts?vue&type=script&lang=ts&"
export * from "./colorpicker.ts?vue&type=script&lang=ts&"
import style0 from "./colorpicker.scss?vue&type=style&index=0&id=5958cd80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5958cd80",
  null
  
)

export default component.exports